import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertaService } from '../../../services/alerta.service';
import { OfferService } from '../../../services/offer.service';
import { FormulaResult } from '../../../models/formulas/formula-resultat';

@Component({
  selector: 'app-formula-evaluator',
  standalone: false,
  templateUrl: './formula-evaluator.component.html',
  styleUrl: './formula-evaluator.component.css'
})
export class FormulaEvaluatorComponent {

  loading: boolean = true;
  formulaResult: FormulaResult[] = [];
  filteredResults: FormulaResult[] = [];
  searchText: string = '';

  constructor(
    private alerta: AlertaService,
    private offerService: OfferService,
    private route: ActivatedRoute,
  ){}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.offerService.formulaEvaluator(id).subscribe({
          next: (formulaResult) =>{
          this.formulaResult = JSON.parse(JSON.stringify(formulaResult));
          this.formulaResult.sort((a, b) =>
            a.variable.localeCompare(b.variable, undefined, { numeric: true, sensitivity: 'base' })
          );
          this.filteredResults = [...this.formulaResult];
          this.loading = false;
          }
          });
      }else{
        this.loading = false;
      }
    });
  }

  applyFilter(event: Event) {

    this.searchText = (event.target as HTMLInputElement).value
      .toLowerCase()
      .trim();
  
    if (!this.searchText) {
      this.filteredResults = [...this.formulaResult];
      return;
    }
  
    this.filteredResults = this.formulaResult.filter(f =>
      f.variable?.toLowerCase().includes(this.searchText) ||
      f.expression?.toLowerCase().includes(this.searchText)
    );
  }
  highlight(text: string): string {

    if (!this.searchText || !text) return text;
  
    const regex = new RegExp(`(${this.searchText})`, 'gi');
  
    return text.replace(regex, '<mark>$1</mark>');
  }
}
